import React, {Component} from 'react';
import {Row, Col, Button } from 'react-bootstrap';
// import relatedBlogImage from '../assets/related-blogs-img.png';

class RelatedBlogs extends Component {
  render() {
    let { articleList, loadMore } = this.props;
    return(
      <Row className="le-related-blogs">
        {
          articleList.length || articleList?articleList.map((article, index) => (
          <Col md={4} className="hazy-content-block" key={index}>
            <div>
              <p>{article.date}</p>
              <h5>{article.title}</h5>
              <a href={`/blog/${article.permalink}`}> 
                <Button className="le-expand-button">+</Button>
                <span>READ MORE</span>
              </a>
              <img src={article.images.thumbnail} alt="recent-news" />
            </div>
          </Col>
          )):null
        }
        {
          loadMore?(
            <Col className="more-button">
              <a href="/blog">View more updates</a>
            </Col>
          ):null
        }
        
      </Row>
    )
  }
}

export default RelatedBlogs;